
import { Docsanfentitywrapper } from '../docsandentitywrapper/docsanfentitywrapper';
import { Side } from '../side/side';
import './content.css';

export const Content = ()=>{
    return(<>
        <main className='connntent'>
            
            <Side />

            <Docsanfentitywrapper />

        </main>
    </>)
};